module.exports = {"id":"236073","name":"Alam Lindeiro","rating":"71","photo":"./data/images/photos/4/236073.png","club":{"name":"Atlético Mineiro","logo":"./data/images/clubs/AtleticoMineiro.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlamLindeiro0.json
// module id = 147
// module chunks = 0